import React from 'react';
import { observer, inject } from 'mobx-react';

import { Locale } from 'chaika-enums';

import { Ehr } from '@patient/store/ehr/Ehr';
import { ViewPortState } from '@store/ViewPort';

import { Center, CenterContentProps } from './Center';
import { withRouter, WithRouterProps } from '@hoc/withRouterProps';
import { AuthUser } from '@store/AuthUser/AuthUser';
import { AppState } from '@store/App/App';

interface Props extends CenterContentProps {}

interface StoreProps {
    app: AppState;
    ehr: Ehr;
    viewPort: ViewPortState;
    authUser: AuthUser;
}

@(withRouter as any)
@observer
class Component extends React.Component<Props & StoreProps & WithRouterProps> {
    public render(): React.ReactNode {
        const { ehr, viewPort, location } = this.props;

        const isMobile = viewPort.isMobileSize;
        const link = `/patient/${ehr.recordId}?currentPage=entry`;
        const isPatientPage = /^\/patient\/[^/]+\/?$/.test(location.pathname);

        return React.createElement(Center, {
            isMobile,
            link,
            isPatientPage,
            recordId: ehr.recordId,
            fullName: this.createFullNameString(),
            birthDate: ehr.birthDate,
            age: ehr.ageString,
            phone: ehr.phone,
            email: ehr.email,
            assistantsChats: ehr.assistantsChats,
        });
    }

    private createFullNameString(): string {
        const {
            ehr,
            viewPort,
            authUser: { selectedLanguage },
        } = this.props;

        let fullName = '';

        if (viewPort.isMobileSize) {
            fullName = selectedLanguage
                ? selectedLanguage === Locale.En
                    ? ehr.engShortFullName
                    : ehr.getShortFullNameByTranslation(selectedLanguage)
                : ehr.shortFullName;
        } else {
            fullName = selectedLanguage
                ? selectedLanguage === Locale.En
                    ? ehr.engFullName
                    : ehr.getFullNameByLang(selectedLanguage)
                : ehr.fullName;
        }

        return fullName;
    }
}

export const CenterContainer = inject<Props, StoreProps>(
    Ehr.Name,
    ViewPortState.Name,
    AuthUser.Name,
    AppState.Name,
)(Component);
